

import React, { useEffect, useState } from 'react';

const MathQuiz = () => {
  const [question, setQuestion] = useState('');
  const [answer, setAnswer] = useState('');
  const [feedback, setFeedback] = useState('');

  useEffect(() => {
    generateQuestion();
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    const recognition = new SpeechRecognition();
    recognition.continuous = true;
    recognition.interimResults = true;
    recognition.lang = 'en-US';

    recognition.onresult = (event) => {
      let finalTranscript = '';
      for (let i = event.resultIndex; i < event.results.length; ++i) {
        if (event.results[i].isFinal) {
          finalTranscript += event.results[i][0].transcript;
        }
      }
      if (finalTranscript) {
        setAnswer(finalTranscript);
        checkAnswer(finalTranscript);
      }
    };

    recognition.start();
    return () => recognition.stop();
  }, []);

  const generateQuestion = () => {
    const num1 = Math.floor(Math.random() * 10) + 1;
    const num2 = Math.floor(Math.random() * 10) + 1;
    setQuestion(`${num1} + ${num2}`);
  };

  const checkAnswer = (answer) => {
    const correctAnswer = eval(question);
    if (parseInt(answer) === correctAnswer) {
      setFeedback('Correct!');
    } else {
      setFeedback('Incorrect, try again.');
    }
    generateQuestion();
  };

  return (
    <div>
      <h2>Math Quiz</h2>
      <p>{question}</p>
      <p>{answer}</p>
      <p>{feedback}</p>
    </div>
  );
};

export default MathQuiz;


